import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { parseJwt } from '../helpers';
import { KeycloakService } from 'keycloak-angular';
import { BaseService } from '../services/base.service';


@Injectable()
export class AuthV2Guard  {
  constructor(
    protected readonly router: Router,
    protected readonly authService: AuthService,
    protected readonly keycloakService: KeycloakService,
    protected readonly baseService: BaseService,
    ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
    if (this.baseService.isCompany()) {
      this.router.navigate(['/crm']);
      return true;
    }
    return true;
  }
}
